<template>
  <div class="footer fixed-content">
    <div class="container-cap">
      <div class="row">
        <div class="col-md-2 col-xs-12 col-md-push-10">
          <div class="row">
            <div class="col-xs-6 col-md-12 internal-links text-right">
              <p>
                <router-link to="/contact">Contact</router-link>
              </p>
              <p class="legal">
                <router-link to="/legal">Mentions légales</router-link>
              </p>
            </div>
            <div class="col-xs-6 col-md-12">
              <a href="https://www.preventioninfection.fr" target="_blank"
              class="pull-right">
                <img class="img-responsive logo-repias"
                     :src="require('@/assets/img/logo-repias.png')"/>
              </a>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-10 col-md-pull-2">
          <div class="row">
            <div class="col-xs-12">
              <p class="copyright">
                Copyright © 2021 Répias, Tous droits réservés.
              </p>
            </div>
            <div
              v-for="(iconLicense, k) in iconsLicenses"
              :key="`iconLicense-${k}`"
              :class="iconLicense.class"
              class="licenses">
              Icône.s conçu.s par
              <ul class="row">
                <li
                  v-for="(creator, creatorKey) in iconLicense.creators"
                  :key="`creator-${creatorKey}`" :class="iconLicense.creatorClass">
                  <a v-if="creator.url" :href="creator.url" target="_blank">
                    {{ creator.name }}
                  </a>
                  <p v-else>{{ creator.name }}</p>
                </li>
              </ul>
              Hébergée.s chez
              <a :href="iconLicense.origin.url" target="_blank">
                {{ iconLicense.origin.name }}
              </a>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'c-footer',
  data: function () {
    return {
      iconsLicenses: [
        {
          class: 'col-md-6 col-xs-12',
          creatorClass: 'col-xs-4 col-sm-3',
          creators: [
            { name: 'Catkuro' },
            { name: 'dDara' },
            { name: 'Freepik', url: 'https://www.freepik.com' },
            { name: 'Geotatah' },
            { name: 'Kiranshastry' },
            { name: 'Mavadee' },
            { name: 'N. Golubev' },
            { name: 'Nhor Phai' },
            { name: 'Pause08' },
            { name: 'Skyclick' },
            { name: 'Smalllikeart' },
            { name: 'Smashicons' },
            { name: 'Srip' },
            { name: 'Surang' },
            { name: 'V. Oviyan' }
          ],
          origin: {
            name: 'Flaticon',
            url: 'https://www.flaticon.com/'
          }
        },
        {
          class: 'col-md-3 col-xs-12',
          creatorClass: 'col-xs-12',
          creators: [
            { name: 'S. Ribecca' },
            { name: 'Atif Arshad' },
            { name: 'throwaway' },
            { name: 'WEBTECHOPS LLP' }
          ],
          origin: {
            name: 'The Noun Project',
            url: 'https://thenounproject.com/'
          }
        }
      ]
    }
  }
}
</script>
<style scoped lang="less">
@import "~variables";

.footer {
  background-color: @base;
  color: white;
  padding: 3rem 0;
  display: flex;
  align-items: center;
  flex-grow: 1;

  a,
  p {
    font-weight: bold;
    color: white;
  }

  p {
    margin-bottom: 0;
  }

  ul {
    list-style-type: none;
    padding-left: 1rem;
    margin-bottom: 0rem;
  }

  .logo-repias {
    padding: 0.5rem;
    max-width: 110px;
    max-height: 90%;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 0.3rem;
  }

  .licenses {
    font-size: 80%;
  }

  .legal {
    padding-bottom: 0.4rem;
  }

  @media (min-width: 0) and (max-width: @screen-sm-max) {
    .container-cap:first-child {
      padding-top: 0rem;

    }
  }

  @media screen and (max-width: 992px) {
    .licenses {
      margin: 0.2rem 0rem;
    }

    .copyright {
      margin-top: 1rem;

    }

    .internal-links {
      padding-top: 1rem;
      text-align: left;
    }
  }
}
</style>
